import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { compose } from 'utils/compose';
import styles from './Header.module.scss';
import Translations from './VendorInformationHeader.translations';

const Header: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.root}>
      <div className={styles.title}>{formatMessage(Translations.VendorInformationHeaderVendorInformation)}</div>
      <div className={styles.subTitle}>
        {formatMessage(Translations.VendorInformationHeaderThisInformationWillBeShownOnGowagoCh)}
      </div>
    </div>
  );
};

export default compose(Header);
